import { createContext, useContext } from 'react';
export const TableContext = /*#__PURE__*/createContext({
  bordered: true,
  condensed: true,
  disableHover: false,
  _exteriorBorders: true,
  tableVariantStyleOverrides: undefined
});

/**
 * Provides the context for the `Table` component.
 * @returns TableContext - The context for the `Table` component.
 */
export const useTableContext = () => {
  return useContext(TableContext);
};